import P from 'components/P';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import React from 'react';
import { pageEH3FontSize } from 'routes/adminMobile/constraints/AdminConst';

const AdminMobileEmptyMsg = () => {
    return (
        <VerticalFlex backgroundColor="white" borderRadius="0.5rem">
            <FlexChild padding="max(1vw, 0.5rem)">
                <P size={pageEH3FontSize}>데이터가 없습니다</P>
            </FlexChild>
        </VerticalFlex>
    );
};

export default AdminMobileEmptyMsg;